import styled from 'styled-components';

export const Wrapper = styled.div((props) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'fixed',
  zIndex: 1000,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  transitionProperty: 'opacity',
  transitionTimingFunction: 'cubic-bezier(0.65, 0, 0.35, 1)',
  transitionDelay: '0s',
  transitionDuration: '0.3s',
}));

export const Inner = styled.div((props) => ({
  maxHeight: 'calc(100vh - 4rem)',
  maxWidth: '92vw',
  width: 'clamp(23rem, 30vw, 35rem)',
  overflowY: 'auto',
  position: 'relative',
  padding: '2rem',
  borderRadius: '0.5rem',
  backgroundColor: 'white',
  h3: {
    marginTop: 0,
  },
}));

export const CloseButton = styled.button({
  opacity: 0.5,
  position: 'absolute',
  border: 'none',
  background: 'none',
  top: 0,
  right: 0,
  padding: '1rem',
});
